import React from 'react';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import RightExerciseTypeList from './RightExerciseTypeList';

const RightExerciseTypes = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Derechos de Agua', icon: 'icon-droplets' },
		{ to: '#', label: 'Configuración', icon: 'icon-settings' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Ejercicio de Derecho' links={breadcrumbLinks} icon={'icon-zap'} />
					<RightExerciseTypeList/>
				</Container>
			</div>
		</React.Fragment>
	);
};

export default RightExerciseTypes;
